import { useRef, useState } from "react";

export function useReasoningManager() {
  const [text, setText] = useState<string>("");
  const [ongoing, setOngoing] = useState(false);
  const ongoingRef = useRef(false);

  function setReasoningOngoing(value: boolean) {
    ongoingRef.current = value;
    setOngoing(value);
  }

  function handleStream(value: string) {
    const closeTagRegex = /<\/REASONING-CBB>/i;
    const openTagRegex = /<REASONING-CBB>/i;

    if (closeTagRegex.test(value)) {
      setReasoningOngoing(false);
      const beforeTag = value.split(closeTagRegex)[0];
      setText((prev) => prev + beforeTag);
      return { ongoing: ongoingRef.current };
    }

    if (openTagRegex.test(value)) {
      setReasoningOngoing(true);
      const afterTag = value.split(openTagRegex)[1];
      setText(afterTag || "");
    } else if (ongoingRef.current) {
      setText((prev) => prev + value);
    }

    return { ongoing: ongoingRef.current };
  }

  function stop(deleteText: boolean = false) {
    if (deleteText) setText("");
    setReasoningOngoing(false);
  }

  function sanitizeTags(value) {
    return value
      .replace(/^[\s\S]*?<\/REASONING-CBB>/gi, "")
      .replace(/<\/?REASONING-CBB>/gi, "");
  }

  return {
    text: text || "",
    ongoing,
    handleStream,
    sanitizeTags,
    stop,
    getReasoning: () => text,
  };
}
